// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deactivated-row {
  background-color: #f5f5f5 !important;
}

h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #1c1c1c;
  font-family: "Roboto", sans-serif !important;
}

:host ::ng-deep * {
  font-family: "Roboto", sans-serif !important;
}

.deactivated-row td:not(.mat-column-actions) {
  opacity: 0.6;
  color: #9e9e9e !important;
}

.deactivated-row .mat-column-actions mat-icon {
  color: black !important;
}

.mat-form-field {
  width: 100%;
}

.mat-column-select {
  width: 40px;
  min-width: 40px;
  padding-right: 0 !important;
}

.mat-column-id {
  width: 50px;
  min-width: 50px;
  padding-right: 5px !important;
}

.mat-column-firstName,
.mat-column-lastName {
  width: 10%;
  min-width: 80px;
}

.mat-column-countryCode {
  width: 7%;
  min-width: 60px;
  text-align: center;
}

.mat-column-phoneNumber {
  width: 10%;
  min-width: 90px;
}

.mat-column-gender {
  width: 6%;
  min-width: 60px;
}

.mat-column-dateOfBirth {
  width: 9%;
  min-width: 90px;
}

.mat-column-email {
  width: 18%;
  min-width: 150px;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mat-column-userStatus {
  width: 8%;
  min-width: 80px;
}

.mat-column-status {
  width: 10%;
  min-width: 90px;
}

.mat-column-actions {
  width: 50px;
  min-width: 50px;
  text-align: center;
  padding-left: 0 !important;
}

th.mat-header-cell,
td.mat-cell {
  padding-left: 8px !important;
  padding-right: 8px !important;
  font-size: 13px !important;
}

.upload-card {
  border-radius: 16px;
  padding: 24px;
}

.upload-box {
  border: 1px dashed #d9d9d9;
  border-radius: 12px;
  padding: 32px 20px;
  background: #fafafa;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
  flex-wrap: wrap;
}

.upload-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-width: 180px;
  padding: 8px 16px;
}

.upload-col-divider {
  width: 1px;
  background-color: #e0e0e0;
  align-self: stretch;
  margin: 0 8px;
}

.btn {
  border-radius: 24px;
  margin-bottom: 12px;
  background: linear-gradient(90deg, #ed845d 0%, #da522f 100%);
  color: #ffffff;
}

.file-info {
  font-size: 13px;
  color: #888;
  margin-top: 8px;
}

.file-name {
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.instruction-body {
  font-size: 14px;
}

.fields-grid {
  display: flex;
  gap: 60px;
  margin-top: 10px;
}

.sample-link {
  color: #1a40c7 !important;
  cursor: pointer;
  text-decoration: underline;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  background: rgba(255, 255, 255, 0.9);
  margin: 20px 0;
}

.loading-text {
  margin-top: 24px;
  font-size: 16px;
  font-weight: 500;
  color: #1c1c1c;
  animation: text-pulse 1.8s ease-in-out infinite;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/careplus/careplus-add-customers/careplus-add-customers.component.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,OAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,+CAA+C;AACjD;;AAEA,4sMAA4sM","sourcesContent":[".deactivated-row {\n  background-color: #f5f5f5 !important;\n}\n\nh2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #1c1c1c;\n  font-family: \"Roboto\", sans-serif !important;\n}\n\n:host ::ng-deep * {\n  font-family: \"Roboto\", sans-serif !important;\n}\n\n.deactivated-row td:not(.mat-column-actions) {\n  opacity: 0.6;\n  color: #9e9e9e !important;\n}\n\n.deactivated-row .mat-column-actions mat-icon {\n  color: black !important;\n}\n\n.mat-form-field {\n  width: 100%;\n}\n\n.mat-column-select {\n  width: 40px;\n  min-width: 40px;\n  padding-right: 0 !important;\n}\n\n.mat-column-id {\n  width: 50px;\n  min-width: 50px;\n  padding-right: 5px !important;\n}\n\n.mat-column-firstName,\n.mat-column-lastName {\n  width: 10%;\n  min-width: 80px;\n}\n\n.mat-column-countryCode {\n  width: 7%;\n  min-width: 60px;\n  text-align: center;\n}\n\n.mat-column-phoneNumber {\n  width: 10%;\n  min-width: 90px;\n}\n\n.mat-column-gender {\n  width: 6%;\n  min-width: 60px;\n}\n\n.mat-column-dateOfBirth {\n  width: 9%;\n  min-width: 90px;\n}\n\n.mat-column-email {\n  width: 18%;\n  min-width: 150px;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mat-column-userStatus {\n  width: 8%;\n  min-width: 80px;\n}\n\n.mat-column-status {\n  width: 10%;\n  min-width: 90px;\n}\n\n.mat-column-actions {\n  width: 50px;\n  min-width: 50px;\n  text-align: center;\n  padding-left: 0 !important;\n}\n\nth.mat-header-cell,\ntd.mat-cell {\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n  font-size: 13px !important;\n}\n\n.upload-card {\n  border-radius: 16px;\n  padding: 24px;\n}\n\n.upload-box {\n  border: 1px dashed #d9d9d9;\n  border-radius: 12px;\n  padding: 32px 20px;\n  background: #fafafa;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 0;\n  flex-wrap: wrap;\n}\n\n.upload-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  min-width: 180px;\n  padding: 8px 16px;\n}\n\n.upload-col-divider {\n  width: 1px;\n  background-color: #e0e0e0;\n  align-self: stretch;\n  margin: 0 8px;\n}\n\n.btn {\n  border-radius: 24px;\n  margin-bottom: 12px;\n  background: linear-gradient(90deg, #ed845d 0%, #da522f 100%);\n  color: #ffffff;\n}\n\n.file-info {\n  font-size: 13px;\n  color: #888;\n  margin-top: 8px;\n}\n\n.file-name {\n  font-weight: 500;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n}\n\n.instruction-body {\n  font-size: 14px;\n}\n\n.fields-grid {\n  display: flex;\n  gap: 60px;\n  margin-top: 10px;\n}\n\n.sample-link {\n  color: #1a40c7 !important;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.loader-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 0;\n  background: rgba(255, 255, 255, 0.9);\n  margin: 20px 0;\n}\n\n.loading-text {\n  margin-top: 24px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #1c1c1c;\n  animation: text-pulse 1.8s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
